import React from "react";
import CustomInputNumber from "./CustomInputNumber";

const Development = () => {

    const [value, setValue] = React.useState<number>(3);

    function changeValue(value: number | null) {
        setValue(value ?? 0);
    }

    return (
        <>
            <CustomInputNumber value={value} max={20} min={0} onChange={changeValue}/>
        </>
    );
}

export default Development;